export const canWriteRecommendations = (user) =>
  user?.role === 'admin' || user?.role === 'collaborator';
